import type { HitlQueueCard } from "../aidwops.types";
import { getRiskTooltip, getPriorityTooltip } from "../aidwops.tooltips.utils";

interface ExpertQueueCardProps {
    item: HitlQueueCard;
    rank: number;
    onOpen: (item: HitlQueueCard) => void;
    isSelected: boolean;
    showAiRecommendation: boolean;
    showStatusInFooter: boolean;
}

export function ExpertQueueCard({
    item,
    rank,
    onOpen,
    isSelected,
    showAiRecommendation,
    showStatusInFooter,
}: ExpertQueueCardProps) {
    const priorityAccent = item.risk === "low" ? "amber" : "red";

    return (
        <article className={`expert-queue-view-card ${isSelected ? "expert-queue-view-card--selected" : ""}`}>
            <div className="expert-queue-view-card-top">
                {rank > 0 && <span
                    className={`expert-queue-view-rank${rank === 1 ? " expert-queue-view-rank--top" : ""}`}
                >
                    {rank}
                </span>}
                <h3 className="expert-queue-view-card-title">{item.title}</h3>
                <span className="expert-queue-view-category">
                    {item.product}
                </span>
                <div
                    className={`expert-queue-view-priority expert-queue-view-priority--${priorityAccent}`}
                    title={getPriorityTooltip(item)}
                >
                    <span className="expert-queue-view-priority-text">
                        <span className="expert-queue-view-priority-value">
                            {item.priority.score}
                        </span>
                        <span className="expert-queue-view-priority-label">
                            Priority
                        </span>
                    </span>
                </div>
            </div>

            <div className="expert-queue-view-tags">
                <span
                    className={`expert-queue-view-tag expert-queue-view-tag--${item.risk}`}
                    title={getRiskTooltip(item)}
                >
                    {item.risk} risk
                </span>
                {item.tag && (
                    <span className="expert-queue-view-tag expert-queue-view-tag--kind">
                        {item.tag}
                    </span>
                )}
                {/* {!showStatusInFooter && item.status !== "awaiting_review" && (
                    <span className="expert-queue-view-tag expert-queue-view-tag--status">
                        {item.statusLabel ?? item.status.replace(/_/g, " ")}
                    </span>
                )} */}
                {item.tags.map((tag) => (
                    <span
                        key={tag}
                        className="expert-queue-view-tag expert-queue-view-tag--context"
                    >
                        {tag}
                    </span>
                ))}
            </div>

            <p className="expert-queue-view-description">{item.subtitle}</p>

            <div className="expert-queue-view-footer">
                {(showAiRecommendation && item.status === "awaiting_review") && (
                    <span className="expert-queue-view-recommend">
                        AI recommends: <strong>{item.recommendation.label}</strong>
                    </span>
                )}
                {(showStatusInFooter || item.status !== "awaiting_review") && (
                    <span className="expert-queue-view-recommend">
                        Status: <strong>{item.statusLabel ?? item.status.replace(/_/g, " ")}</strong>
                    </span>
                )}
                {!isSelected && (
                    <button
                        type="button"
                        className="expert-queue-view-open"
                        onClick={() => onOpen(item)}
                    >
                        Open <span aria-hidden="true">&rarr;</span>
                    </button>
                )}
            </div>
        </article>
    );
}

export default ExpertQueueCard;
